import ThumbnailCard from "@components/Blocks/Card/Thumbnail/ThumbnailCard";
import AdsContainer from "@components/Blocks/Container/AdsContainer";
import SubSectionNav from "@components/Blocks/SubSectionNav/SubSectionNav";
import LoadMore from "@components/Modules/LoadMore/LoadMore";
import { CompanionAdsLb } from "@elements/Advertisement/variant/CompanionAdsLb";
import VideoPlayerSticky from "@elements/Player/VideoPlayerSticky";
import { SectionTitleV2 } from "@elements/Typography/TitleV2";
import { displayAfter, isArrayWithElements } from "@helper/utils";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { PageAdTargetValue } from "@typings/Ads.d";
import type { LatestVideoResponse } from "@typings/Brightcove.d";
import { ReactNode } from "react";

type VideoPageNewProps = {
  playing: LatestVideoResponse | undefined;
  containerRef: React.RefObject<HTMLDivElement | null>;
  videos: LatestVideoResponse[] | undefined;
  sectionName: string;
  pageAdTargetValue: PageAdTargetValue;
  handleOnEndedVideo: () => void;
  handleOnClickThumbnail: (props: LatestVideoResponse) => void;
  handleLoadMoreVideo: () => Promise<number>;
};

const PAGE_SIZE = 8;

export default function VideoPageNew(props: VideoPageNewProps) {
  const {
    playing,
    containerRef,
    videos,
    sectionName,
    pageAdTargetValue,
    handleOnEndedVideo,
    handleOnClickThumbnail,
    handleLoadMoreVideo,
  } = props;

  const displaySectionName = "Multimedia";

  return (
    <>
      <WidgetWrapper>
        <SectionTitleV2 sectionName={displaySectionName} />
        <SubSectionNav
          sectionName={sectionName}
          displaySection={displaySectionName}
        />
      </WidgetWrapper>
      {playing?.id && (
        <VideoPlayerSticky
          playing={playing}
          forwardedRef={containerRef}
          onEnded={handleOnEndedVideo}
          nextPlaylist={handleOnEndedVideo}
          showDescription={true}
        />
      )}

      {isArrayWithElements(videos) &&
        videos.reduce((acc: ReactNode[], _, index) => {
          // Insert an ad every PAGE_SIZE articles, outside the wrapper
          if (displayAfter(index, PAGE_SIZE)) {
            acc.push(
              <AdsContainer key={`ad-${index}`}>
                <CompanionAdsLb
                  uniqueSectionName={sectionName}
                  index={index / PAGE_SIZE}
                  pageAdTargetType={pageAdTargetValue}
                  stripeBackground={false}
                  overRideSlot={false}
                  applySizeMapping={true}
                />
              </AdsContainer>,
            );
          }
          // Start a new batch every 8 articles
          if (index % PAGE_SIZE === 0) {
            acc.push(
              <WidgetWrapper key={`batch-${index}`} className="my-[20px]">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {videos.slice(index, index + PAGE_SIZE).map((video, idx) => (
                    <ThumbnailCard<LatestVideoResponse>
                      key={`video-${index}-${idx}`}
                      handleOnClickThumbnail={handleOnClickThumbnail}
                      variant="video"
                      {...video}
                    />
                  ))}
                </div>
              </WidgetWrapper>,
            );
          }

          return acc;
        }, [])}
      <div className="my-md">
        <LoadMore
          onLoadMore={handleLoadMoreVideo}
          loadText="Laporan lain videos"
          virtualPVTitle="Videos"
          pageNumber={0}
        />
      </div>
    </>
  );
}
